// Copyright ©️ 2026 eVolve MEP, LLC

import { convertInchesToImperialString } from 'helpers/convertInchesToImperialString';

/**
 * One span of a dimension chain, as the drawing reads it. Inches only, however wide the rack gets — that is
 * what a shop drawing shows.
 *
 * Formatting is a UI decision, so it belongs on this side of the feature; it lives on the manager rather
 * than in the React layer because `cullRepeatedChains` needs it too, to group chains on exactly the numbers
 * a fabricator sees. Quantizing separately for the cull would let the two drift.
 */
export const formatSpanFt = (spanFt: number): string => convertInchesToImperialString(spanFt * 12);
